<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>操作人：</label>
                    <el-input v-model="search_Obj.f_real_name" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>模块：</label>
                    <el-select v-model="search_Obj.f_module_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('module_type')" :key="'module_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>操作类型：</label>
                    <el-select v-model="search_Obj.f_operation_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('operation_type')" :key="'operation_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>操作时间：</label>
                    <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="dateRangeSet"
                        style="width:420px">
                    </el-date-picker>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card class="box-card">
                <div class="mainBody">
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column prop="real_name" label="操作人" sortable="custom" width="140"></el-table-column>
                            <el-table-column prop="module_type" label="所在模块" sortable="custom" width="160">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.module_type, "module_type") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operation_type" label="操作类型" sortable="custom" width="140">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.operation_type, "operation_type") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="add_time" label="操作时间" sortable="custom" width="220">
                                <template slot-scope="scope">
                                    <span>{{ formatDate1(scope.row.add_time, "yyyy-mm-dd HH:mm:ss") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="日志描述" sortable="custom"></el-table-column>
                            <el-table-column label="操作" width="120" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <Info
            width="600px"
            :id="model_id"
            title="查看操作日志"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'systemLogList',
    mixins: [listutil],
    components: { Info, LabBtns},
    data() {
        return {
            m_name: '操作日志',
            menu_id: 2300,
            list_url: "/api/admin/systemlog/list",
            search_Obj: {
                f_real_name: '',
                f_platform_type: '',
                f_module_type: '',
                f_operation_type: '',
                f_add_time_s_date: '',
                f_add_time_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/systemlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['platform_type', 'operation_type', 'module_type'],
            dateRange: [],
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
    }
};
</script>